/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-01-09",
    versionChannel: "nightly",
    buildDate: "2024-01-09T00:15:31.411Z",
    commitHash: "6e1e26e0e8ef26aaee6c5c361191475dc33eb5d1",
};
